export default __webpack_public_path__ + "static/slogan-2-2b69c36d6cecb753f307a607b55dd0f7.png";